import { render, staticRenderFns } from "./OpportunityShare.vue?vue&type=template&id=0cd6de93"
import script from "./OpportunityShare.vue?vue&type=script&lang=js"
export * from "./OpportunityShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cd6de93')) {
      api.createRecord('0cd6de93', component.options)
    } else {
      api.reload('0cd6de93', component.options)
    }
    module.hot.accept("./OpportunityShare.vue?vue&type=template&id=0cd6de93", function () {
      api.rerender('0cd6de93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Opportunity/OpportunityShare.vue"
export default component.exports